import { BlankLayout } from '@/components/layouts';

export default
{
  path: '/quote',
  name: 'Quote',
  component: BlankLayout,
  meta: { module: '报价' },
  children: [
    {
      path: '/quote/free',
      name: 'Quote.Free',
      component: () => import(/* webpackChunkName: 'quote-free' */ '../../views/quote/QuoteFree.vue'),
      meta: { title: '免费报价' },
    },
    {
      path: '/quote/result/:id',
      name: 'Quote.Result',
      component: () => import(/* webpackChunkName: 'quote-result' */ '../../views/quote/QuoteResult.vue'),
      meta: { title: '报价结果' },
    },
  ],
};
